import { InfiniteScroll } from 'antd-mobile-v5';
import EmptyRecord from '@/components/EmptyRecord';
import { jumpToPageByH5, renderFloat, reducerDate } from '@/utils/fn';
import { DEFAULT_GROUP_ITEM } from '../const';
import styles from '../index.less';

const IncomeDetailList = ({ gid, incomeDetail, hasMore, loadMore }) => {
  const jumpToSday = (e, item) => {
    e && e.preventDefault();
    if (gid === DEFAULT_GROUP_ITEM.gid) {
      jumpToPageByH5(`/income/list/sday?time=${reducerDate(item.d)}`);
    }
  };

  const renderIncomeDetail = (d, c, cb) => {
    if (c > 0 && cb === 0) {
      return (
        <div className={styles.incomeDetailItem}>
          <p className={styles.date}>{reducerDate(d)}</p>
          <div className={styles.ydTitle}>
            <span className={styles.value}>+{c}元</span>
          </div>
        </div>
      );
    }
    if (cb > 0 && c === 0) {
      return (
        <div className={styles.incomeDetailItem}>
          <p className={styles.date}>{reducerDate(d)}</p>
          <div className={styles.ydTitle}>
            <span className={styles.value}>
              +{cb}云豆
              {cb > 0 && (
                <span className={styles.cloudBeanEquel}>（≈{renderFloat(cb / 100)}元）</span>
              )}
            </span>
          </div>
        </div>
      );
    }
    if (cb > 0 && c > 0) {
      return (
        <div className={styles.incomeDetailItem}>
          <p className={styles.date}>{reducerDate(d)}</p>
          <div className={styles.ydTitle}>
            <span className={styles.value}>+{c}元</span>
          </div>
          <div className={styles.ydTitle}>
            <span className={styles.value}>
              +{cb}云豆
              {cb > 0 && (
                <span className={styles.cloudBeanEquel}>（≈{renderFloat(cb / 100)}元）</span>
              )}
            </span>
          </div>
        </div>
      );
    }
    return (
      <div className={styles.incomeDetailItem}>
        <p className={styles.date}>{reducerDate(d)}</p>
        <div className={styles.ydTitle}>
          <span className={styles.value}>{cb}</span>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.incomeDetailWrapper}>
      {incomeDetail?.length ? (
        <div forceRender>
          <ul className={styles.incomeList}>
            {incomeDetail.map((income, idx) => {
              const { d, c, cb } = income;
              return (
                <li
                  onClick={e => jumpToSday(e, income)}
                  key={d + idx}
                  className={`${styles.incomeDetail} ${
                    gid === DEFAULT_GROUP_ITEM.gid ? styles.all : styles.group
                  }`}
                >
                  {/* TODO：这里的日历的样式，单行和双行的不一样的设计图，到底已哪个为准 */}
                  {renderIncomeDetail(d, c, cb)}
                </li>
              );
            })}
          </ul>
          <InfiniteScroll hasMore={hasMore} loadMore={loadMore} className={styles.myLoadMore}>
            {hasMore ? <span>加载中...</span> : <span>仅支持查看近3个月数据</span>}
          </InfiniteScroll>
        </div>
      ) : (
        <EmptyRecord text="暂无明细" img="no-commodity.png" imgClass={styles.emptyImage} />
      )}
    </div>
  );
};
export default IncomeDetailList;
